import { GenericGridSmartViewsNirvanaDataProvider } from '../dataProvider/GenericGridSmartViewsNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class GenericGridSmartViewsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, GenericGridSmartViewsNirvanaDataProvider);
  }
}
